/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import 'moment/locale/fr';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { loadRuntimeConfig } from '@environments/runtime-config';
import { reportStartupFailure } from '@environments/startup-failure';
import { appConfig } from './app/app.config';
import { Embedding, isEmbedded } from './app/shared/shell/shell-protocol';
import { demoTourId, tabStorage } from './app/features/tours/demo/demo-mode';
import { App } from './app/app';

registerLocaleData(localeFr, 'fr-FR');

// Embarquée dans l'Espace Pilotage — adresse `?embarque=1`, dans un cadre, `coque` déclarée —,
// l'application le sait avant l'annuaire et avant que rien ne s'affiche (contrat des logiciels,
// § 2) ; sinon elle s'ouvre seule, exactement comme sans le paramètre.
function embeddingOf(coque: string): Embedding | null {
  const parent = window.parent !== window ? window.parent : null;
  const embedded = isEmbedded(coque, window.location.search, parent);
  document.documentElement.classList.toggle('embarque', embedded);
  return embedded && parent ? { coque, parent, self: window } : null;
}

// `/config.json` est lu AVANT de construire les providers : c'est lui qui désigne l'API et
// l'annuaire, et Keycloak s'initialise dès le démarrage de l'application. Une même image sert
// ainsi le dev, la production et toutes les previews qui la déclarent.
// Un onglet ouvert sur `/decouverte/…` démarre en démonstration, pour toute sa vie : ses appels
// à l'API ne quittent pas le navigateur. Son code se charge à part, et seulement là.
loadRuntimeConfig()
  .then(async (runtimeConfig) => {
    const embedding = embeddingOf(runtimeConfig.coque);
    const tourId = demoTourId(window.location.pathname, tabStorage());
    const demo = tourId
      ? (await import('./app/features/tours/demo/demo.providers')).demoProviders(
          tourId,
          runtimeConfig.apiUrl,
        )
      : [];
    return bootstrapApplication(App, appConfig(runtimeConfig, demo, embedding));
  })
  .catch((failure) => reportStartupFailure(failure));
